import React from "react";
import { COLOR_CLASSES } from "@/lib/format";

export function Badge({ color = "muted", children, className = "", ...props }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] font-medium uppercase tracking-wider border rounded-sm ${COLOR_CLASSES[color] || COLOR_CLASSES.muted} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

export function StatusDot({ color = "muted", className = "" }) {
  const map = {
    success: "bg-emerald-500",
    warning: "bg-amber-500",
    error: "bg-rose-500",
    info: "bg-sky-500",
    awaiting: "bg-violet-500",
    muted: "bg-slate-600",
  };
  return <span className={`inline-block w-2 h-2 rounded-full ${map[color]} ${className}`} />;
}

export function Panel({ title, action, children, className = "", testid }) {
  return (
    <div className={`bg-surface border border-line rounded-sm ${className}`} data-testid={testid}>
      {(title || action) && (
        <div className="flex items-center justify-between px-4 py-3 border-b border-line">
          <h3 className="text-xs font-semibold uppercase tracking-[0.15em] text-slate-300">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}

export function StatCard({ label, value, sub, accent = "text-cyan", testid }) {
  return (
    <div className="bg-surface border border-line rounded-sm p-4" data-testid={testid}>
      <div className="text-[10px] font-medium uppercase tracking-[0.15em] text-slate-400 mb-2">{label}</div>
      <div className={`text-3xl font-bold tabular-nums font-mono ${accent}`}>{value}</div>
      {sub && <div className="text-xs text-slate-400 mt-1.5">{sub}</div>}
    </div>
  );
}
